<template>
  <div
    class="product-item shadow"
    :class="{ active: isActive, detailPopup: isDetailPopup }"
    :data-productid="item.PRODUCT_ID"
  >
    <div v-show="isExtraRatioShow()" class="product-tag">
      +{{ extraRatio() }}
      <img
        v-if="bonusIcon"
        class="bonus-icon"
        :src="bonusIcon"
        alt="bonus-icon"
      />
    </div>
    <div class="product-item-detail" @click="showDetailPopup(item)">
      <gift-icon
        :background="getGiftBanckground(item)"
        :gifts="getGiftIcons(item)"
      ></gift-icon>
      <product-info
        :productName="getProductName(item)"
        :productDetail="getProductDetail(item)"
        @selectProduct="selectProduct"
        @clickAddToCart="clickAddToCart"
        :price="item.GAME_AMOUNT"
        :item="item"
        :isPreProduct="isPreProduct"
      ></product-info>
    </div>
    <PopupWindow
      v-if="visibleInterceptPopup"
      type="tips"
      :languages="letter"
      :title="interceptTitle"
      :content="interceptTip"
      :confirm="interceptConfirm"
      textAlign="center"
      @onConfirm="hideInterceptPopup"
      @onCancel="hideInterceptPopup"
    ></PopupWindow>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ProductInfo from '@components/officialTopup/product/ProductInfo.vue';

import cartAddAndDetail from '@mixins/officialTopup/cartAddAndDetail';
import product from '@mixins/officialTopup/product';
import productName from '@mixins/product';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV3';
import ruProductIntercept from '@mixins/officialTopup/ruProductIntercept';
export default {
  name: 'ProductItem',
  mixins: [product, productName, cartAddAndDetail, ruProductIntercept],
  props: ['item', 'selectItem', 'isPreProduct', 'isDetailPopup'],
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      currency: state => state.showCurrency,
      picList: state => state.page.picList
    }),
    ...mapGetters(['isJpPlatform']),
    isActive() {
      if (this.isPreProduct || this.isDetailPopup) {
        return false;
      }
      return (
        this.item.PRODUCT_ID == this.selectItem.PRODUCT_ID &&
        this.item.CP_PRODUCT_ID == this.selectItem.CP_PRODUCT_ID
      );
    },
    bonusIcon() {
      return this.picList?.bonus || '';
    }
  },
  methods: {
    isExtraRatioShow() {
      return this.extraRatio() !== '0%';
    },
    extraRatio() {
      if (!this.item.EXTRA_RATIO) return '0%';
      return (parseFloat(this.item.EXTRA_RATIO) * 100).toFixed(0) + '%';
    },
    selectProduct(item) {
      if (this.handleProductIntercept(item)) {
        this.$emit('selectProduct', item);
      }
    },
    clickAddToCart(item) {
      if (this.handleProductIntercept(item)) {
        this.$emit('clickAddToCart', item);
      }
    },
    showDetailPopup(item) {
      if (this.handleProductIntercept(item)) {
        this.$emit('showDetailPopup', {
          ...item,
          showBtn: !this.isPreProduct
        });
      }
      clickButton({
        btnName: 'confirm_product',
        locationKey: locationType.selectProduct
      });
    }
  },
  components: {
    ProductInfo
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopup/officialTopup.scss';
@import '@assets/scss/officialTopup/_dimen.scss';
.product-item {
  position: relative;
  box-sizing: border-box;
  width: 315px;
  cursor: pointer;
  background: #fff;
  margin-bottom: 30px;
  border-radius: 20px;
  &.detailPopup {
    border: unset;
    width: 100%;
    margin-bottom: 0;
    .choose {
      display: none;
    }
  }
  .product-tag {
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 10px;
    top: 10px;
    font-size: 20px;
    color: #333333;
    padding: 0 20px;
    height: 30px;
    @include g-gradient-btn();
    border-radius: 16px 0 16px 0px;
    background-size: cover;
    box-sizing: border-box;

    .bonus-icon {
      width: 100%;
      height: 100%;
      margin-left: 10px;
    }
  }
  &-detail {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    .product-name {
      font-size: 22px;
      color: $commodityNameColor;
      margin-bottom: 5px;
      font-weight: normal;
    }

    .product-price {
      font-size: 28px;
      color: $themeColor;
      font-weight: bold;
    }
    .double-tip {
      display: flex;
      align-items: center;
      font-size: 20px;
      color: $commodityNameColor;
      .double-ico {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
    }
  }
  .choose {
    display: block;
    position: absolute;
    right: 3px;
    bottom: 3px;
    font-size: 27px;
    color: #dddddd;
    &.active {
      color: $themeColor;
    }
  }
}

@media screen and (orientation: landscape) {
  .product-item {
    width: 345px;
    margin-right: 40px;
    &:nth-child(3n) {
      margin-right: 0;
    }
    .product-tag {
      font-size: 20px;

      .ico {
        display: inline-block;
        background-size: cover;
        width: 18px;
        height: 15px;
      }
    }
    &-detail {
      .product-name {
        font-size: 18px;
        margin-bottom: 13px;
      }

      .product-price {
        font-size: 22px;
      }
      .double-tip {
        font-size: 16px;
      }
    }
    .choose {
      font-size: 23px;
    }
  }
}
</style>
